export const createCategoryUrl = ({ id }: { id: number | string }) =>
  `/c/${id}?showProducts=true`;

export const createProductUrl = ({ id }: { id: number | string }) => `/p/${id}`;
